export const NOTIFICATION_ITEM_HEIGHT = 93;
